import { TAX_CODE } from "../../../common/constants/COMMON";
import { OffsetCost, SummaryDataStateType } from "./entity/Entity";

const totalOffsetSummary = (value: any) => {
  let result = 0;
  // const offsetArray = (value?.offsetCostSummary ?? []).concat(value?.offsetCost ?? []);
  const offsetArray = value?.offsetCostSummary ?? [];
  offsetArray.forEach((element: any) => {
    result += element?.value ?? 0;
  });
  return result;
};
const totalOffsetAmount = (value: any) => {
  let result = 0;
  const offsetArray = value?.offsetCost ?? [];
  offsetArray.forEach((element: any) => {
    result += element?.value ?? 0;
  });
  return result;
};

const getOffsetValue = (record: any, taxFree?: boolean) => {
  const noData = 0;

  if (!record.offsetCost) return noData;

  const offsetCost = record.offsetCost?.find(
    (element: OffsetCost) =>
      element.category.code === (taxFree ? TAX_CODE.TAX_FREE : TAX_CODE.TAX)
  );

  if (!offsetCost) return noData;

  return offsetCost?.value ?? 0;
};
const getOffsetSummaryValue = (record: any, taxFree?: boolean) => {
  const noData = 0;

  if (!record.offsetCostSummary) return noData;

  const offsetCostSummary = record.offsetCostSummary?.find(
    (element: OffsetCost) =>
      element.category.code === (taxFree ? TAX_CODE.TAX_FREE : TAX_CODE.TAX)
  );

  if (!offsetCostSummary) return noData;

  return offsetCostSummary?.value ?? 0;
};
const getDataWithFormula = (outsourceCompanyData: any[]) => {
  const summaryData: SummaryDataStateType = {
    actualCost: 0,
    consumptionTax: 0,
    totalOffset: 0,
    paymentAmountExcludingTax: 0,
    paymentAmountIncludingTax: 0,
    offsetCostTax: 0,
    offsetCostTaxFree: 0,
    offsetCostSummaryTax: 0,
    offsetCostSummaryTaxFree: 0,
  };

  const results: any[] = outsourceCompanyData.map((companyElement: any) => {
    let totalTaxCompany: number = 0;

    let sumActualCost: number = 0;
    let sumTotalOffset: number = 0;
    let sumPaymentExcludingTax: number = 0;

    const formulatedProjectList = companyElement?.projectList.map((project: any) => {
      let totalTaxProject: number = 0;

      const formulatedOutsourceCost = project?.outsourceCost.map((cost: any) => {
        const totalOffset = totalOffsetAmount(cost) + totalOffsetSummary(cost);

        const paymentAmountExcludingTax = Math.max(0, (cost?.actualCost ?? 0) - totalOffset);

        const consumptionTax = Math.floor(
          (paymentAmountExcludingTax +
            getOffsetValue(cost) +
            getOffsetSummaryValue(cost)) *
          (cost?.taxSetting ?? 0.1)
        );

        const paymentAmountIncludingTax = paymentAmountExcludingTax + consumptionTax;

        totalTaxProject += consumptionTax;

        return {
          ...cost,
          totalOffset,
          paymentAmountExcludingTax,
          paymentAmountIncludingTax,
          consumptionTax,
          companyName: companyElement?.company?.name ?? "",
        };
      });

      const totalOffset = totalOffsetAmount(project) + totalOffsetSummary(project);

      const paymentAmountExcludingTax = Math.max(0, (project?.actualCost ?? 0) - totalOffset);

      const consumptionTax = Math.floor(
        (paymentAmountExcludingTax +
          getOffsetValue(project) +
          getOffsetSummaryValue(project)) *
        (companyElement?.taxSetting ?? 0.1)
      );

      const paymentAmountIncludingTax = paymentAmountExcludingTax + consumptionTax;

      sumActualCost += (project?.actualCost ?? 0);
      sumTotalOffset += totalOffset;
      sumPaymentExcludingTax += paymentAmountExcludingTax;
      totalTaxCompany += consumptionTax;

      return {
        ...project,
        outsourceCost: formulatedOutsourceCost,
        totalOffset,
        paymentAmountExcludingTax,
        paymentAmountIncludingTax,
        consumptionTax,
      };
    });

    const companyOffset = totalOffsetAmount(companyElement) + totalOffsetSummary(companyElement);
    const totalOffset = companyOffset;

    const paymentAmountExcludingTax = Math.max(0, sumPaymentExcludingTax - companyOffset);

    const isCompanyOn = (companyElement?.actualCost ?? 0) > 0;
    const additionalConsumptionTax = isCompanyOn
      ? Math.floor(
        (totalTaxCompany + getOffsetSummaryValue(companyElement)) *
        (companyElement?.taxSetting ?? 0.1)
      )
      : 0;

    const consumptionTax = totalTaxCompany + additionalConsumptionTax;
    const paymentAmountIncludingTax = paymentAmountExcludingTax + consumptionTax;

    summaryData.actualCost += sumActualCost;
    summaryData.consumptionTax += consumptionTax;
    summaryData.totalOffset += totalOffset;
    summaryData.paymentAmountExcludingTax += paymentAmountExcludingTax;
    summaryData.paymentAmountIncludingTax += paymentAmountIncludingTax;
    summaryData.offsetCostTax += getOffsetValue(companyElement);
    summaryData.offsetCostTaxFree += getOffsetValue(companyElement, true);
    summaryData.offsetCostSummaryTax += getOffsetSummaryValue(companyElement);
    summaryData.offsetCostSummaryTaxFree += getOffsetSummaryValue(companyElement, true);

    return {
      ...companyElement,
      actualCost: sumActualCost,
      projectList: formulatedProjectList,
      totalOffset,
      paymentAmountExcludingTax,
      paymentAmountIncludingTax,
      consumptionTax,
    };
  });

  return { data: results, summary: summaryData };
};

export {
  totalOffsetSummary as totalOffsetAmountCompany,
  totalOffsetAmount,
  getDataWithFormula,
};
